export const getTokenfromUserObj=()=>{
let userObj=JSON.parse(localStorage.getItem('user'));
let token=userObj?userObj.token:" ";
return token;
}

